import { gql } from '@apollo/client';

export const ADD_PERSON_TO_ORGANISATION = gql`
  mutation AddPersonToOrganisation($inputs: AddStakeholderToOrganisationInput) {
    person: addStakeholderToOrganisation(inputs: $inputs) {
      id
      name
    }
  }
`;
